import styled from 'styled-components'

/**
 * Official colors for a status indicator
 */
export const StatusIconColor = {
  green: '#ADD950',
  red: '#F4505B',
  border: '#F7F6F5'
}

/**
 * Styled dot indicator for customer service availability
 * We could also use the SVG. From a visual point of view, it looks the same.
 */
export const IconDot = styled.div<{ isOk?: boolean }>`
  width: 20px; /* Diameter of the dot */
  height: 20px;
  background-color: ${({ isOk }) => (isOk ? StatusIconColor.green : StatusIconColor.red)};
  border: 3px solid ${StatusIconColor.border}; /* White outline */
  border-radius: 50%; /* Makes it round */
  display: inline-block;
  margin-right: 0.5em;
`
